import { makeStyles } from '@material-ui/core/styles';
import { input } from 'UI/constants/dimensions';
import { colors } from 'UI/res';
import { getInverseSurface } from 'UI/theme/darkTones';

export const useStyles = makeStyles(theme => ({
  card: {
    ...theme.input,
    height: input.height,
    margin: 0,
    '& div': {
      height: 'auto !important'
    },
    display: 'flex',
    justifyContent: 'space-between',
    textTransform: 'lowercase',
    color: theme.palette.common.white,
    fontSize: 16,
    fontWeight: 300,
    alignItems: 'center',
    padding: '0px 0px 0px 25px',
    position: 'relative'
  },
  progress: {
    color: theme.palette.success.main
  },
  cardAction: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    display: 'flex',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    paddingLeft: 25,
    paddingRight: 48
  },
  button: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    top: 0
  },
  loading: {
    backgroundColor: getInverseSurface(theme, colors.darkGrey)
  },
  finished: {
    backgroundColor: colors.silverGrey,
    color: colors.black
  },
  success: {
    backgroundColor: theme.palette.success.main
  },
  error: {
    backgroundColor: colors.silverGrey,
    borderWidth: 1,
    color: colors.black,
    border: `1px solid ${theme.palette.error.main}`,
    marginBottom: 15
  },
  errorLabel: {
    color: theme.palette.error.main,
    top: '100%',
    position: 'absolute',
    zIndex: 1
  }
}));
